import React from "react";
import { useCurrentUser } from "../../../utils/CurrentUserContext";
import Table from "../../../components/lists/Table/Table";
import { DatePicker } from "antd";
import { useState, useMemo } from "react";
import dayjs from "dayjs";
import { useCubeQuery } from "../../../utils/hooks/useCubeQuery";
import useCubeClient from "../../../utils/cubejs-client";
import { useLocation } from "react-router-dom";
import { useCampaignReport } from "../../../utils/api/reports";
import Spinner from "../../../components/icons/Spinner";

function useParamQuery() {
  return new URLSearchParams(useLocation().search);
}

const AdvancedBilling = () => {
  const {user} = useCurrentUser();
  let pQuery = useParamQuery();
  const cubejsApi = useCubeClient()
  const advertiserId = pQuery.get("advertiserid");
  const [startOfMonth, setStartOfMonth] = useState(dayjs().startOf("month"));
  const [endOfMonth, setEndOfMonth] = useState(dayjs().endOf("month"));

  // Create separate state variables for query
  const queryStart = useMemo(
    () => startOfMonth.format("YYYY-MM-DD"),
    [startOfMonth]
  );
  const queryEnd = useMemo(() => endOfMonth.format("YYYY-MM-DD"), [endOfMonth]);

  const {
    loading: campiLoading,
    error: campiError,
    data: campiData,
  } = useCampaignReport({
    startDate: queryStart,
    endDate: queryEnd,
    filters: { publisherId: user.companyId, advertiserId: advertiserId },
  });

  let cubeFilters = [
    {
      member: "aggregateTdLevel.reads",
      operator: "gt",
      values: ["0"],
    },
    {
      member: "aggregateTdLevel.publicationId",
      operator: "set",
    },
    {
      member: "aggregateTdLevel.publisherId",
      operator: "set",
    },
  ];

  if (advertiserId) {
    cubeFilters.push({
      member: "aggregateTdLevel.advertiserId",
      operator: "equals",
      values: [advertiserId],
    });
  }

  const { resultSet, error, isLoading } = useCubeQuery(
    {
      order: {
        "aggregateTdLevel.totalCost": "desc",
      },
      measures: [
        "aggregateTdLevel.reads",
        //        "Params_Event.cta_clicks",
        "aggregateTdLevel.totalCost",
      ],
      limit: 5000,
      dimensions: [
        "aggregateTdLevel.campaignId",
        "aggregateTdLevel.publisherId",
        "aggregateTdLevel.websiteId",
        "aggregateTdLevel.publicationId",
      ],
      timeDimensions: [
        {
          dimension: "aggregateTdLevel.date",
          dateRange: [queryStart, queryEnd],
        },
      ],
      filters: cubeFilters,
    },
    { cubejsApi }
  );

  const campaignColumns = [
    {
      title: "Campaign",
      // Instead of using dataIndex for nested properties, use render function
      render: (text, record) => record.campaign.name,
      key: "name",
    },
    {
      title: "Publisher",
      render: (text, record) => record.website.publisher.name,
      key: "publisher",
    },
    {
      title: "Website",
      render: (text, record) => record.website.name,
      key: "website",
    },
    {
      title: "Reads",
      dataIndex: "reads",
      key: "reads",
    },
    /*    {
      title: "Clicks",
      dataIndex: "clicks",
      key: "clicks",
    }, */
    {
      title: "Cost",
      dataIndex: "payout",
      key: "cost",
    },
    /*{
      title: "Budget",
      dataIndex: "budget",
      key: "budget",
    },*/
  ];

  const onDateChange = (dates) => {
    // Update the start and end of month when a new date range is selected
    if (dates && dates.length === 2) {
      setStartOfMonth(dates[0]);
      setEndOfMonth(dates[1]);
    }
  };
  if (campiLoading || campiError || !campiData) {
    return <Spinner />;
  }
  return (
    <div className="pb-4 bg-white rounded-lg shadow-lg py-2">
      <div className="px-2 sm:px-6 lg:px-4 py-4">
        <div className="sm:flex sm:items-center p-2">
          <div className="sm:flex-auto">
            <h1 className="text-lg leading-6 font-medium text-gray-900 pb-2">
              Billing
            </h1>
            <DatePicker.RangePicker
              allowClear={false}
              onChange={onDateChange}
              defaultValue={[startOfMonth, endOfMonth]}
            />
          </div>
        </div>
        {
          <Table
            className="mt-4"
            columns={campaignColumns}
            data={campiData.CampaignReport}
            searchable={false}
          />
        }
      </div>
    </div>
  );
};

export default AdvancedBilling;
